import { useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "./AuthContext";

function Shell({ title, children }) {
  return (
    <div className="min-h-screen bg-ink-950 text-white">
      <div className="grain" aria-hidden="true" />
      <div className="mx-auto flex min-h-screen max-w-md flex-col justify-center px-6">
        <Link to="/" className="mb-8 font-oswald text-sm uppercase tracking-[0.25em]">Nou La Baby<span className="text-gold">.</span></Link>
        <h1 className="mb-8 font-oswald text-5xl font-700 uppercase leading-[0.85] tracking-tighter">{title}</h1>
        {children}
      </div>
    </div>
  );
}

const input = "w-full border border-white/15 bg-transparent px-4 py-3.5 text-sm outline-none focus:border-gold";
const btn = "flex w-full items-center justify-center gap-2 bg-gold py-4 font-mono text-[12px] uppercase tracking-[0.25em] text-ink-950 disabled:opacity-60";

export function LoginPage() {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState(""); const [password, setPassword] = useState("");
  const [err, setErr] = useState(""); const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setErr("");
    const r = await login(email, password);
    setBusy(false);
    if (r.ok) nav(loc.state?.from || "/events"); else setErr(r.error);
  };

  return (
    <Shell title="Log In">
      <form onSubmit={submit} className="grid gap-4" data-testid="login-form">
        <input data-testid="login-email" className={input} type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required />
        <input data-testid="login-password" className={input} type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} required />
        {err && <p className="text-sm text-red-400" data-testid="login-error">{err}</p>}
        <button className={btn} data-testid="login-submit" disabled={busy}>{busy ? <Loader2 size={16} className="animate-spin" /> : "Enter"}</button>
      </form>
      <p className="mt-6 text-center text-sm text-zinc-500">No account? <Link to="/register" className="text-gold">Sign up</Link></p>
    </Shell>
  );
}

export function RegisterPage() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState(""); const [email, setEmail] = useState(""); const [password, setPassword] = useState("");
  const [err, setErr] = useState(""); const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setErr("");
    const r = await register(name, email, password);
    setBusy(false);
    if (r.ok) nav("/events"); else setErr(r.error);
  };

  return (
    <Shell title="Sign Up">
      <form onSubmit={submit} className="grid gap-4" data-testid="register-form">
        <input data-testid="register-name" className={input} placeholder="Name" value={name} onChange={(e) => setName(e.target.value)} required />
        <input data-testid="register-email" className={input} type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required />
        <input data-testid="register-password" className={input} type="password" placeholder="Password (min 6 chars)" value={password} onChange={(e) => setPassword(e.target.value)} required />
        {err && <p className="text-sm text-red-400" data-testid="register-error">{err}</p>}
        <button className={btn} data-testid="register-submit" disabled={busy}>{busy ? <Loader2 size={16} className="animate-spin" /> : "Create Account"}</button>
      </form>
      <p className="mt-6 text-center text-sm text-zinc-500">Have an account? <Link to="/login" className="text-gold">Log in</Link></p>
    </Shell>
  );
}
